import { getCssVar } from "@/utils";

export function createNaiveThemeOverrides() {
  return {
    common: {
      borderRadius: "0.625rem",
      primaryColor: getCssVar("--smoe-primary-500"),
      primaryColorHover: getCssVar("--smoe-primary-700"),
      primaryColorPressed: getCssVar("--smoe-primary-500"),
      borderColor: getCssVar("--smoe-border"),
      lineHeight: getCssVar("--smoe-line-height"),
    },
    Button: {
      fontSizeTiny: "0.875rem",
      fontSizeSmall: "0.9375rem",
      fontSizeMedium: "1rem",
      fontSizeLarge: "1.0625rem",

      heightTiny: "2.5rem",
      heightSmall: "2.75rem",
      heightMedium: "3rem",
      heightLarge: "3.25rem",

      paddingTiny: "0 0.5rem",
      paddingSmall: "0 0.75rem",
      paddingMedium: "0 1rem",
      paddingLarge: "0 1rem",

      paddingRoundTiny: "0 0.5rem",
      paddingRoundSmall: "0 0.75rem",
      paddingRoundMedium: "0 1rem",
      paddingRoundLarge: "0 1rem",

      iconMarginTiny: "0.5rem",
      iconMarginSmall: "0.5rem",
      iconMarginMedium: "0.5rem",
      iconMarginLarge: "0.5rem",
    },
    Card: {
      borderColor: getCssVar("--smoe-border"),
    },
    Checkbox: {
      borderRadius: "0.25rem",
      fontSizeMedium: "1rem",
      fontSizeLarge: "1.125rem",
      sizeMedium: "1.25rem",
      sizeLarge: "1.5rem",
      textColor: getCssVar("--smoe-gray-800"),
      labelPadding: "0 0 0 0.5rem",
      colorDisabled: getCssVar("--smoe-gray-300"),
      colorDisabledChecked: getCssVar("--smoe-gray-100"),
    },
    Dropdown: {
      dividerColor: getCssVar("--smoe-border"),
      optionIconSizeLarge: "20px",
    },
    Radio: {
      radioSizeMedium: "1.5rem",
      fontSizeMedium: "1rem",
      radioSizeMedium: "1.25rem",
      textColor: getCssVar("--smoe-gray-800"),
      labelPadding: "0 0 0 0.5rem",
    },
    Divider: {
      color: getCssVar("--smoe-border"),
    },
    Input: {
      fontSizeTiny: "0.875rem",
      fontSizeSmall: "0.9375rem",
      fontSizeMedium: "1rem",
      fontSizeLarge: "1.0625rem",

      heightTiny: "2.5rem",
      heightSmall: "2.75rem",
      heightMedium: "3rem",
      heightLarge: "3.25rem",

      borderFocus: `1px solid ${getCssVar("--smoe-gray-500")}`,
      borderHover: `1px solid ${getCssVar("--smoe-gray-500")}`,
      borderActive: `1px solid ${getCssVar("--smoe-gray-500")}`,
      boxShadowFocus: "none",
      caretColor: getCssVar("--smoe-gray-800"),
      placeholderColor: getCssVar("--smoe-gray-500"),
      textColor: getCssVar("--smoe-gray-800"),
      textColorDisabled: getCssVar("--smoe-gray-500"),
    },
    Select: {
      peers: {
        InternalSelection: {
          fontSizeTiny: "0.875rem",
          fontSizeSmall: "0.9375rem",
          fontSizeMedium: "1rem",
          fontSizeLarge: "1.0625rem",

          heightTiny: "2.5rem",
          heightSmall: "2.75rem",
          heightMedium: "3rem",
          heightLarge: "3.25rem",

          borderFocus: `1px solid ${getCssVar("--smoe-gray-500")}`,
          borderHover: `1px solid ${getCssVar("--smoe-gray-500")}`,
          borderActive: `1px solid ${getCssVar("--smoe-gray-500")}`,
          boxShadowFocus: "none",
          boxShadowActive: "none",
          placeholderColor: getCssVar("--smoe-gray-500"),
          textColor: getCssVar("--smoe-gray-800"),
          textColorDisabled: getCssVar("--smoe-gray-500"),
        },
        InternalSelectMenu: {},
      },
    },
    Pagination: {
      buttonIconColor: getCssVar("--smoe-gray-700"),
      buttonBorder: "none",
      buttonBorderHover: "none",
      buttonBorderPressed: "none",
      itemBorder: "none",
      itemBorderHover: "none",
      itemBorderPressed: "none",
      itemBorderActive: "none",
      itemBorderDisabled: "none",
      itemBorderRadius: "100%",
      itemColorActive: getCssVar("--smoe-primary-500"),
      itemColorActiveHover: getCssVar("--smoe-primary-500"),
      itemTextColor: getCssVar("--smoe-gray-700"),
      itemTextColorHover: getCssVar("--smoe-gray-700"),
      itemTextColorDisabled: getCssVar("--smoe-gray-700"),
      itemTextColorActive: getCssVar("--smoe-white"),
      itemMarginMedium: "0 0 0 8px",
      itemPaddingMedium: "0",
      itemSizeMedium: "2.5rem",
      itemFontSizeMedium: "1rem",
    },
  };
}
